import { Action, DialogActions } from '@e3dc-react/shell/Elements/Dialog/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

/** Dialog Actions adapted to the use in the advanced-setting-dialogs */
export interface UseDialogActionsParams {
  primary: Action
  secondary: UseDialogAction
  additional?: UseDialogAction
}
/** Dialog Action Button values but with optional name */
type UseDialogAction = Partial<Action>

/** Hook to generate dialog actions */
export const useDialogActions = ({ primary, secondary, additional }: UseDialogActionsParams): DialogActions => {
  const { t } = useCustomTranslation()

  const additionalActions = additional
    ? {
        name: t('common.delete'),
        onClick: additional.onClick,
        disabled: additional.disabled,
        isLoading: additional.isLoading,
      }
    : undefined

  return {
    additional: additionalActions,
    secondary: {
      name: t('common.cancel'),
      onClick: secondary.onClick,
      disabled: secondary.disabled,
    },
    primary: primary,
  }
}
